// extracted by mini-css-extract-plugin
module.exports = {"main-region":"_1410bfd27b--main-region--aLm6T","clickable-text":"_1410bfd27b--clickable-text--P_aGv"};